"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const icons_1 = require("@ant-design/icons");
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const constants_1 = require("../../../assets/constants/constants");
const _360Suites_White_svg_1 = __importDefault(require("../../../assets/images/360Suites_White.svg"));
const RoutesPaths_1 = require("../../../routes/RoutesPaths");
const detectDevice_1 = __importDefault(require("../../../utils/detectDevice"));
require("./LandingFooterStyles.scss");
const LandingFooter = () => {
    const history = (0, react_router_dom_1.useHistory)();
    const route = (0, react_router_dom_1.useLocation)();
    const { isMobile } = (0, detectDevice_1.default)(900);
    const scrollTop = () => {
        if (route.pathname === RoutesPaths_1.routesPaths.landingPage) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        else {
            history.push('/');
        }
    };
    const PolicyContainer = (react_1.default.createElement("div", { className: "LandingPolicyContainer" },
        react_1.default.createElement(react_router_dom_1.Link, { to: {
                pathname: RoutesPaths_1.routesPaths.privacy,
                state: { from: route.pathname },
            } }, "Pol\u00EDtica de privacidade"),
        react_1.default.createElement(react_router_dom_1.Link, { to: {
                pathname: RoutesPaths_1.routesPaths.cancel,
                state: { from: route.pathname },
            } }, "Pol\u00EDtica de Cancelamento"),
        react_1.default.createElement(react_router_dom_1.Link, { to: {
                pathname: RoutesPaths_1.routesPaths.terms,
                state: { from: route.pathname },
            } }, "Termos de uso")));
    const Logo360 = (react_1.default.createElement("div", { className: "CopyrightContainer" },
        react_1.default.createElement("button", { style: { background: 'none', border: 'none' }, type: "button", onClick: () => scrollTop() },
            react_1.default.createElement("img", { className: "logo", src: _360Suites_White_svg_1.default, alt: "360 Suites Logo" })),
        !isMobile && (react_1.default.createElement("span", { className: "Copyright" },
            "Copyright \u00A9",
            new Date().getFullYear(),
            ".",
            react_1.default.createElement("span", null, constants_1.CURRENT_VERSION && `v${constants_1.CURRENT_VERSION}`)))));
    const handleWhatsApp = (0, react_1.useCallback)((cellPhone) => {
        const phone = cellPhone.replace(/[^0-9]/g, '');
        window.open(`https://api.whatsapp.com/send?phone=${phone}`, '_blank');
    }, []);
    const contentFactory = () => {
        if (isMobile) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: "CopyrightContainer" },
                    react_1.default.createElement("button", { style: { background: 'none', border: 'none' }, type: "button", onClick: () => scrollTop() },
                        react_1.default.createElement("img", { src: _360Suites_White_svg_1.default, alt: "360 Suites Logo" })),
                    react_1.default.createElement("div", { className: "mobile-contact" },
                        react_1.default.createElement("span", null,
                            react_1.default.createElement(icons_1.MailOutlined, null),
                            constants_1.CLIENT_INFORMATIONS.LPemail),
                        react_1.default.createElement("span", { onClick: () => handleWhatsApp(constants_1.OWNER_INFORMATIONS.cell), style: { cursor: 'pointer' } },
                            react_1.default.createElement(icons_1.WhatsAppOutlined, null),
                            constants_1.OWNER_INFORMATIONS.cell),
                        react_1.default.createElement("span", null,
                            react_1.default.createElement(icons_1.PhoneOutlined, null),
                            constants_1.CLIENT_INFORMATIONS.telephone),
                        react_1.default.createElement("div", { className: "address" },
                            `${constants_1.CLIENT_INFORMATIONS.address}, ${constants_1.CLIENT_INFORMATIONS.number}`,
                            react_1.default.createElement("br", null),
                            `${constants_1.CLIENT_INFORMATIONS.neighborhood}, ${constants_1.CLIENT_INFORMATIONS.city} / ${constants_1.CLIENT_INFORMATIONS.state}`,
                            react_1.default.createElement("br", null),
                            `CEP / ${constants_1.CLIENT_INFORMATIONS.CEP}`)),
                    react_1.default.createElement("div", { className: "socialMedia" },
                        react_1.default.createElement("a", { href: "https://www.linkedin.com/company/360suites/", target: "_blank", rel: "noreferrer" },
                            react_1.default.createElement(icons_1.LinkedinFilled, null)),
                        react_1.default.createElement("a", { href: "https://www.facebook.com/360suites/", target: "_blank", rel: "noreferrer" },
                            react_1.default.createElement(icons_1.FacebookFilled, null)),
                        react_1.default.createElement("a", { href: "https://www.instagram.com/360suites/", target: "_blank", rel: "noreferrer" },
                            react_1.default.createElement(icons_1.InstagramFilled, null))),
                    react_1.default.createElement("span", { className: "CopyrightM Mobile" },
                        "Copyright \u00A9",
                        new Date().getFullYear(),
                        ".",
                        react_1.default.createElement("span", null, constants_1.CURRENT_VERSION && `v${constants_1.CURRENT_VERSION}`))),
                react_1.default.createElement("div", { className: "PolicyContainer" },
                    react_1.default.createElement(react_router_dom_1.Link, { to: {
                            pathname: RoutesPaths_1.routesPaths.privacy,
                            state: { from: route.pathname },
                        }, className: "Policy" }, "Pol\u00EDtica de privacidade"),
                    react_1.default.createElement(react_router_dom_1.Link, { to: {
                            pathname: RoutesPaths_1.routesPaths.cancel,
                            state: { from: route.pathname },
                        }, className: "Policy" }, "Pol\u00EDtica de Cancelamento"),
                    react_1.default.createElement(react_router_dom_1.Link, { to: {
                            pathname: RoutesPaths_1.routesPaths.terms,
                            state: { from: route.pathname },
                        }, className: "Policy" }, "Termos de uso"))));
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            Logo360,
            PolicyContainer));
    };
    return react_1.default.createElement("div", { className: "HomeFooterBottomBar" }, contentFactory());
};
exports.default = LandingFooter;
